import cx from 'classnames';
import {useCallback, useMemo} from 'react';

type Props = {
    id?: string;
    name: string;
    className?: string;
    labelPlacement?: 'left' | 'right'
    label?: string | React.ReactElement;
    value: any;
    disabled?: boolean;
    checked?: boolean;
    children?: React.ReactNode;
    onSelect?: (value: any) => void;
}

export type RadioProps = Props;

export const Radio: React.FC<Props> = ({name, className, value, label, labelPlacement = 'left', children, onSelect, ...props}: Props) => {
    const id = useMemo(() => `radio-${props.id || value}`, [props.id, value]);

    const handleSelect = useCallback(() => {
        onSelect(value);
    }, [value, onSelect]);

    return (
        <label
            htmlFor={id}
            className={cx('tw-flex tw-relative tw-items-center', {
                'tw-text-default-dimmed': props.disabled,
                'tw-cursor-pointer': !props.disabled && !props.checked
            }, className)}
        >
            <input
                {...props}
                id={id}
                name={name}
                type='radio'
                className='tw-absolute tw-opacity-0'
                onChange={handleSelect}
            />
            <span className={cx('tw-w-5 tw-h-5 tw-rounded-full tw-bg-light', {
                'tw-border tw-border-default': !props.checked,
                'tw-border-6 tw-border-dark': props.checked,
                'tw-bg-default': props.disabled,
                'tw-order-2': labelPlacement === 'right'
            })}
            />
            {label && <span className={labelPlacement === 'right' ? 'tw-mr-2' : 'tw-ml-2'}>{label}</span>}
            {!label && children}
        </label>
    );
};
